import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

import { IntlProvider, addLocaleData } from 'react-intl';
import { Provider } from 'react-redux';
import en from 'react-intl/locale-data/en';
import cs from 'react-intl/locale-data/cs';
import da from 'react-intl/locale-data/da';
import de from 'react-intl/locale-data/de';
import es from 'react-intl/locale-data/es';
import fi from 'react-intl/locale-data/fi';
import fr from 'react-intl/locale-data/fr';
import he from 'react-intl/locale-data/he';
import id from 'react-intl/locale-data/id';
import it from 'react-intl/locale-data/it';
import ja from 'react-intl/locale-data/ja';
import ko from 'react-intl/locale-data/ko';
import ms from 'react-intl/locale-data/ms';
import nl from 'react-intl/locale-data/nl';
import no from 'react-intl/locale-data/no';
import ro from 'react-intl/locale-data/ro';
import pl from 'react-intl/locale-data/pl';
import pt from 'react-intl/locale-data/pt';
import ru from 'react-intl/locale-data/ru';
import sv from 'react-intl/locale-data/sv';
import th from 'react-intl/locale-data/th';
import tl from 'react-intl/locale-data/tl';
import tr from 'react-intl/locale-data/tr';
import vi from 'react-intl/locale-data/vi';
import zh from 'react-intl/locale-data/zh';
import mo from 'react-intl/locale-data/mo'; // obsolete code used for our gibberish file

import Logger from './functions/logging';

import store from '../src/redux/store';
import * as locale from './functions/locale';
import ReactGA from 'react-ga4';
import mixpanel from 'mixpanel-browser';
// Our translated strings
// import localeData from './../../build/locales/data.json';
import localeData from './locales/data.json';
import settings from './libs/config';
import GlobalAnalyticsAdapter from './analytics/GlobalAnalyticsAdapter';
import DeviceHelper from './functions/device';


ReactGA.initialize([{ trackingId: settings.gaCode }]);
mixpanel.init("502fda98b8a2ad9ef45b7cd6ceff0aad");

addLocaleData([
	...en,
	...cs,
	...da,
	...de,
	...es,
	...fi,
	...fr,
	...he,
	...id,
	...it,
	...ja,
	...ko,
	...ms,
	...nl,
	...no,
	...pl,
	...pt,
	...ro,
	...ru,
	...sv,
	...th,
	...tl,
	...tr,
	...vi,
	...zh,
	...mo,
]);

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
const urlParams = new URLSearchParams(window.location.search);
const urlLang = urlParams.get('lang');
if (urlLang && locale.getLocale() !== urlLang) {
	locale.setLocale(urlLang);
}

let language = (navigator.languages && navigator.languages[0]) ||
	navigator.language ||
	navigator.userLanguage;

let languageWithoutRegionCode = locale.getLocale();
if (!languageWithoutRegionCode) {
	languageWithoutRegionCode = locale.getLocale();
}
if (!languageWithoutRegionCode) {
	// Split locales with a region code
	languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
}

// language = "es-ES";
Logger.log("index.js", language, locale.getLocale(), languageWithoutRegionCode, urlLang);

// Try full locale, try locale without region code, fallback to 'en'
const messages = localeData[languageWithoutRegionCode] || localeData[language] || localeData.en;

//Enable right to left when the languge is hebrew
const isRightToLeft = languageWithoutRegionCode === 'he' || language === 'he';
if (!DeviceHelper.isMobile && isRightToLeft) {
	document.documentElement.dir = 'rtl';
}

// Logger.log("index.js", "messages", messages);

let globalAnalyticsAdapter = new GlobalAnalyticsAdapter();

store.dispatch({ type: 'STORE_GLOBAL_ANALYTICS_ADAPTER', globalAnalyticsAdapter });
store.dispatch({ type: 'STORE_GA_TRACKER', gaTracker: ReactGA });
ReactGA.event({
	category: 'User',
	action: 'Created an Account'
});


// testing
window.getState = store.getState;

ReactDOM.render(
	<Provider store={store}>
		<IntlProvider locale={languageWithoutRegionCode} messages={messages} >
			<App />
		</IntlProvider>
	</Provider>,
	document.getElementById('root')
);

// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js